<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Bucket lists</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen
            v-if="!loaded"
            message="Loading bucket list statistics…"
        />
        <section v-else class="max-width-container">
            <article>
                <h2>Bucket Lists</h2>
                <DataTable v-if="loaded" :table="tables.lists" />
                <div class="multi-chart">
                    <BaseChart
                        v-if="loaded"
                        name="Summary"
                        :options="charts.summary"
                    />
                    <BaseChart
                        v-if="loaded"
                        name="Unchecked per type"
                        :options="charts.unchecked"
                        :height="300"
                    />
                </div>
            </article>
            <article>
                <h2>Countries</h2>
                <DataTable v-if="loaded" :table="tables.countries" />
                <MetricRegionMap :entries="map" :metrics="metrics" />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import BaseChart from "js/components/charts/BaseChart";
import MetricRegionMap from "js/components/blocks/MetricRegionMap";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";
import { formatQuantity } from "js/lib/format.js";
import { getBarChart, getSimplePieChart, COLORS } from "js/lib/charts.js";

export default {
    components: {
        LoadingScreen,
        DataTable,
        BaseChart,
        MetricRegionMap,
    },
    data() {
        return {
            loaded: false,
            map: [],
            tables: {},
            charts: {},
            metrics: [
                {
                    key: "items",
                    label: "Items",
                    popup: (entry) => ({
                        title: formatQuantity(entry.items, "item"),
                        progress: entry.success,
                    }),
                },
                {
                    key: "checked",
                    label: "Checked",
                    popup: (entry) => ({
                        title: `${entry.checked} of ${entry.items} checked`,
                        progress: entry.success,
                    }),
                },
                {
                    key: "success",
                    label: "Success",
                    format: (value) => `${value}%`,
                    bands: [
                        [0, 0],
                        [1, 24],
                        [25, 49],
                        [50, 74],
                        [75, 99],
                        [100, 100],
                    ],
                    popup: (entry) => ({
                        title: `${entry.success}% done${entry.success === 100 ? " 🎉" : ""}`,
                        progress: entry.success,
                    }),
                },
                {
                    key: "lists",
                    label: "Bucket lists",
                    popup: (entry) => ({
                        title: formatQuantity(entry.lists, "bucket list"),
                        lines: [entry.bucket_list_name_entries.join(" · ")],
                        progress: entry.success,
                    }),
                },
            ],
        };
    },
    async mounted() {
        let main = fetch("/api/stats/bucket-lists");
        let country = fetch("/api/stats/countries/bucket-lists");

        this.initBucketLists((await main).data);
        this.initBucketListItemsPerCountry((await country).data);

        this.loaded = true;
    },
    methods: {
        initBucketLists(instructions) {
            this.tables.lists = instructions.table;

            let summary = instructions.summary;
            this.charts.summary = getSimplePieChart(
                "Items",
                ["Checked", "Unchecked"],
                [summary.completed, summary.open],
                [COLORS.green, COLORS.blue]
            );

            let chart = instructions.charts.open;
            this.charts.unchecked = getBarChart(
                chart.labels,
                [
                    {
                        label: "Checked",
                        data: chart.lines.completed,
                        backgroundColor: COLORS.green,
                    },
                    {
                        label: "Unchecked",
                        data: chart.lines.open,
                        backgroundColor: COLORS.blue,
                    },
                ],
                {
                    scales: {
                        y: { stacked: true, beginAtZero: true },
                        x: { stacked: true, stepSize: 1 },
                    },
                }
            );
        },
        initBucketListItemsPerCountry(instructions) {
            this.tables.countries = instructions.table;
            this.map = instructions.maps.countries;
        },
    },
};
</script>
